import React from 'react';
import { YStack, Text } from 'tamagui';
import { tokens } from 'tamagui-config';

interface PinIndicatorProps {
  pin: string[];
  pinError: string | null;
}

export const PinIndicator: React.FC<PinIndicatorProps> = ({ pin, pinError }) => (
  <YStack flexDirection="column" alignItems="center" gap="$5">
    <YStack flexDirection="row" justifyContent="center" alignItems="center" gap="$4">
      {pin.map((digit, index) => (
        <YStack
          key={index}
          width={32}
          height={32}
          backgroundColor={
            pinError
              ? tokens.color.warningRed
              : digit
                ? tokens.color.white12
                : tokens.color.transparent
          }
          borderRadius="50%"
          borderWidth={3}
          borderColor={pinError ? tokens.color.warningRed : tokens.color.white12}
          justifyContent="center"
          alignItems="center"
        />
      ))}
    </YStack>
    <Text
      fontFamily="$body"
      fontSize="$6"
      color={pinError ? tokens.color.warningRed : tokens.color.transparent}>
      {pinError || '...'}
    </Text>
  </YStack>
);
